import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { CUSTOMER_TABS, ROUTES } from '@/app/routes';
import { useGetCustomerShippingDetailsQuery } from '@/lib/api/lookupsApi';
import { EMPTY_LIST } from '@/lib/utils';

// The customer's saved site ids (minus the one being edited) — what a site card must not reuse.
export const useExistingSiteIds = (customerId, excludeSiteId) => {
  const { data: sites = EMPTY_LIST } = useGetCustomerShippingDetailsQuery(customerId);
  return useMemo(
    () =>
      sites
        .filter((site) => site.id !== String(excludeSiteId ?? ''))
        .map((site) => site.code)
        .filter(Boolean),
    [sites, excludeSiteId],
  );
};

// Back to the customer's Site details tab — where both sites pages close to.
export const useGoToCustomerSites = (customerId) => {
  const navigate = useNavigate();
  return useCallback(
    () => navigate(ROUTES.customerDetail(customerId, CUSTOMER_TABS.sites)),
    [navigate, customerId],
  );
};
